import TableRenderer from './TableRenderer';

export default TableRenderer;
